import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const masonhubSettings = defineIntegrationSettings({
  fields: {
    accountSlug: z.string().trim().min(1, "Account slug is required"),
    sandboxMode: z.boolean(),
    createReturns: z.boolean(),
  },
  secrets: { apiToken: z.string().trim().min(1, "API token is required") },
  connectOnly: {},
  computed: {},
});
